// extracted by mini-css-extract-plugin
export default {"App":"app_App__OHAPD","mainPage":"app_mainPage__B9Rs7"};